import { Icon, Typography } from '@scale/scaleui';
import { IPlatinumInfo } from '@scale/shared-types';
import _ from 'lodash';

interface PlatinumInfoSectionProps {
  data: IPlatinumInfo | null;
  isLoading: boolean;
}

export const PlatinumInfoSection: React.FC<PlatinumInfoSectionProps> = (
  props: PlatinumInfoSectionProps,
) => {
  const { data, isLoading } = props;

  return (
    <div className="flex flex-col gap-2 bg-neutral-0 p-4 border border-neutral-200 rounded-md w-[200px]">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-2">
          <Icon hasBackground className="bg-neutral-100" icon={['far', 'shield']} />
          <Typography.Subtitle2>Platinum Info</Typography.Subtitle2>
        </div>
      </div>
      {isLoading && <div>Loading...</div>}
      {!isLoading && _.isEmpty(data) && <div>No platinum info found</div>}
      {!isLoading && !_.isEmpty(data) && data && (
        <>
          <div>
            Platinum Disabled:{' '}
            <span className="font-medium">{data.platinumDisabled ? 'True' : 'False'}</span>
          </div>
          <div>
            Program Status: <span className="font-medium">{data.programStatus}</span>
          </div>
          <div>
            Quality Status: <span className="font-medium">{data.qualityStatus}</span>
          </div>
          <div>
            Hours Worked Status:{' '}
            <span className="font-medium">{data.overallWeeklyHoursWorkedStatus}</span>
          </div>
          <div>
            Start Date:{' '}
            <span className="font-medium">
              {new Date(data.platinumStartDate).toLocaleDateString()}
            </span>
          </div>
        </>
      )}
    </div>
  );
};
